'use client';

/**
 * @module
 * @category Component
 */

import 'BomdisoftComponents/dialogs/styles.css';
import { Dialog, DialogContent } from 'BomdisoftComponents/dialog/index';
import { SharedDialogsEnum, useSharedDialogStore } from 'BomdisoftComponents/dialogs/store';
import { PrivacyPolicy } from 'BomdisoftComponents/privacy-policy/index';

type PrivacyPolicyDialogProps = {
  companyName: string;
  supportEmail: string;
  lang?: string;
};

export const PrivacyPolicyDialog = ({ companyName, supportEmail }: PrivacyPolicyDialogProps) => {
  const activeDialog = useSharedDialogStore(store => store.activeDialog);
  const closeDialog = useSharedDialogStore(store => store.closeDialog);

  return (
    <Dialog className='bomdisoft-dialogs-content-dialog' onClose={closeDialog} open={activeDialog === SharedDialogsEnum.PRIVACY_POLICY}>
      <DialogContent className='bomdisoft-dialogs-content'>
        <PrivacyPolicy companyName={companyName} supportEmail={supportEmail} />
      </DialogContent>
    </Dialog>
  );
};
